import { render, staticRenderFns } from "./YouthInfluence.vue?vue&type=template&id=0d235042&"
import script from "./YouthInfluence.vue?vue&type=script&lang=js&"
export * from "./YouthInfluence.vue?vue&type=script&lang=js&"
import style0 from "./YouthInfluence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports